<template>
    <Container>
        <template v-slot:header>
            <div class="page-title">
                {{ title }}
            </div>
        </template>
        <slot></slot>
    </Container>
</template>
<script>
export default {
    name: "ChildLayout",
    props: { title: String },
};
</script>
